<template>
  <b-modal
    ref="replyMessageModal"
    :title="`${update ? 'Update': 'Create New'} Reply message`"
    modal-class="reply-message-modal"
    hide-footer
    size="md"
    :static="true"
    @hidden="restoreMessage()">
    <b-row
      v-if="changeableType && !message.type"
      class="reply-types clearfix mb-3">
      <b-col
        md="6"
        class="px-0">
        <div
          class="reply-type text"
          @click="setMessageType('text')">
          <img src="~@/assets/img/add-text.svg">
          <span class="type-title">Add Text</span>
        </div>
      </b-col>
      <!--<b-col
        md="4"
        class="px-0">
        <div
          class="reply-type link"
          @click="setMessageType('link')">
          <img src="~@/assets/img/add-link.svg">
          <span class="type-title">Add Link</span>
        </div>
      </b-col>-->
      <b-col
        md="6"
        class="px-0">
        <div
          class="reply-type file"
          @click="setMessageType('file')">
          <img src="~@/assets/img/add-file.svg">
          <span class="type-title">Add File</span>
        </div>
      </b-col>
    </b-row>
    <div v-show="message.type !== ''">
      <div
        v-show="message.type === 'text'"
        class="text-message">
        <MessageTextArea
          ref="messageArea"
          :enter-submit="false"
          :disabled-tag-sources="['agent']"
          placeholder="Enter response here..."/>
        <span
          v-if="errors.has('text')"
          class="validation-error">{{ errors.first('text') }}</span>
      </div>
      <b-input
        v-model="message.text"
        v-validate="'required'"
        name="text"
        data-vv-as="Reply message"
        type="text"
        class="d-none"
        placeholder="Add Text"/>
      <!--<div v-show="message.type === 'link'">
        <b-input
          v-validate="`${message.type === 'link' ? 'required' : ''}`"
          v-model="message.url"
          name="link"
          data-vv-as="Link"
          type="text"
          placeholder="Add Link"/>
        <span
          v-if="errors.has('link')"
          class="validation-error">{{ errors.first('link') }}</span>
      </div>-->
      <template v-if="message.type === 'file'">
        <div class="upload-zone">
          <template v-if="!loading">
            <file-upload
              ref="fileUpload"
              :drop="true"
              :size="16 * 1024 * 1024"
              @input-file="inputFile">
              <div v-if="!fileData.name">
                Drop file here or<br>
                <span class="btn btn-main btn-round mt-2">Select file</span>
              </div>
              <template v-else>
                <span
                  v-if="!fileErrorMessage && fileData.name"
                  class="media-name">
                  <icon
                    v-if="fileData.icon"
                    :name="fileData.icon"
                    class="main-icon"/><span class="float-left">{{ fileData.name }}</span>
                </span>
                <span
                  v-if="fileErrorMessage"
                  class="media-error">
                  <icon
                    name="regular/times-circle"
                    class="main-icon"/><span class="float-left">{{ fileErrorMessage }}</span>
                </span>
                <icon
                  class="mt-1"
                  name="upload"/>
              </template>
            </file-upload>
          </template>
          <div
            v-else
            class="loading"><div class="loader"><div class="loading-circle"/></div>
          </div>
        </div>
      </template>
      <div
        v-if="changeableType"
        class="reply-requirement">
        <SwitchCheckbox
          :id="message.id"
          v-model="message.requires_reply"
          size="mini"
          @input="changeRequiresReply"/>
        <label
          :for="message.id"
          class="require-label">
          Message requires answer (keywords will not be triggered)
          <icon
            id="default_reply_description"
            v-b-tooltip="getTooltipConfig('After sending this message bot will wait for contact reply to continue the sequence. Keywords will not be triggered if contact reply contains any.')"
            name="info-circle"
            class="info-label"/>
        </label>
      </div>
      <b-button
        :disabled="loading || saving"
        class="btn-round btn-block mt-5 mb-3"
        @click="saveMessage">
        Save
      </b-button>
    </div>
  </b-modal>
</template>

<style lang="scss">
.reply-message-modal {
  .modal-body {
    padding: 0 50px 20px;
  }

  .reply-types {
    .reply-type {
      margin: 5px;
      padding: 30px;
      text-align: center;
      color: $bluePrimary;
      font-weight: 500;
      border: 1px solid $lightGray;
      border-radius: 10px;
      font-size: 13px;
      cursor: pointer;

      .type-title {
        display: block;
        margin-top: 10px;
      }

      img {
        width: 24px;
        height: 24px;
      }

      &.text {
        img {
          width: 20px;
        }
      }

      &:hover {
        border: 1px solid $bluePrimary;
      }
    }
  }

  .reply-requirement {
    margin-top: 20px;

    .rounded-checkbox-wrapper {
      margin-top: 2px;
      float: left;

      .rounded-checkbox input[type=checkbox]:checked + label {
        background-color: $bluePrimary;
      }
    }

    .require-label {
      width: 80%;
      margin: 0 6px;
      text-transform: initial;
      font-size: 13px;
      font-weight: 500;
      line-height: 16px;

      svg {
        width: 13px;
        height: 13px;
        cursor: pointer;
        vertical-align: -3px;
      }
    }
  }

  .emojionearea {
    width: 100% !important;
    float: none !important;
    padding: 0 !important;
    box-shadow: none !important;


    .emojionearea-editor {
      min-height: 70px !important;
      max-height: 250px !important;
      padding: 10px !important;
    }
  }

  .action-buttons {
    display: block;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
    padding-left: 30px;
    float: none;

    img {
      width: 18px;
      height: 18px;
    }
  }
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex';
import FileUpload from 'vue-upload-component';
import { getMediaType, getMediaIcon } from '@/helpers/mediaHelpers';
import MessageTextArea from '../../../common/MessageTextArea';
import SwitchCheckbox from '../../../common/SwitchCheckbox';

export default {
  name: 'ReplyMessageModal',
  components: {
    MessageTextArea,
    FileUpload,
    SwitchCheckbox,
  },
  props: {
    changeableType: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      message: {
        type: '',
        text: '',
        url: '',
        mime_type: '',
      },
      fileData: {
        icon: '',
        name: '',
      },
      saving: false,
      loading: false,
      rollbackMessage: true,
      messageBackup: {},
      fileErrorMessage: '',
    };
  },
  computed: {
    ...mapGetters({
      uploadedFile: 'automation/uploadedFile',
      instantReplySaved: 'automation/instantReplySaved',
      fileUploadError: 'automation/fileUploadError',
    }),
    update() {
      return this.message.id && !this.message.id.includes('temp-');
    },
  },
  watch: {
    instantReplySaved(saved) {
      if (saved) {
        this.saving = false;
      }
    },
    uploadedFile(fileData) {
      if (fileData && (this.message.id === fileData.message_id)) {
        this.message.text = fileData.file.original_name;
        this.message.url = fileData.file.url;
        this.message.temp_file = true;
        this.message.mime_type = fileData.file.mime_type;
        this.loading = false;
      }
    },
    fileUploadError(errorData) {
      if (errorData.error) {
        this.loading = false;
        switch (errorData.error.status) {
          case 422: {
            this.fileErrorMessage = errorData.error.data.errors.file[0];
            break;
          }
          case 413: {
            this.fileErrorMessage = 'File is too big. Max size 16MB.';
            break;
          }
          default: {
            this.fileErrorMessage = 'Something went wrong.';
            break;
          }
        }
      }
    },
  },
  methods: {
    ...mapActions({
      uploadTempFile: 'automation/uploadTempFile',
    }),
    getTooltipConfig(text) {
      return {
        title: text,
        placement: 'right',
        animation: false,
        offset: '0, 5px',
      };
    },
    show() {
      this.messageBackup = this.$lodash.clone(this.message);
      this.$refs.replyMessageModal.show();
    },
    hide() {
      this.$refs.replyMessageModal.hide();
    },
    restoreMessage() {
      if (this.rollbackMessage) {
        // need to add values one by one to have affect on message in messages list
        this.message.text = this.messageBackup.text;
        this.message.type = this.messageBackup.type;
        this.message.url = this.messageBackup.url;
        this.message.mime_type = this.messageBackup.mime_type;
        this.message.requires_reply = this.messageBackup.requires_reply;
      }

      this.rollbackMessage = true;
    },
    setMessage(message) {
      if (message.type === 'text') {
        this.$refs.messageArea.setText(message.text);
      } else if (message.type === 'file') {
        this.fileData = {
          icon: getMediaIcon(message.mime_type),
          name: message.text,
        };
      } else {
        this.fileData = {
          icon: '',
          name: '',
        };
      }

      this.message = message;
    },
    inputFile(file) {
      if (file) {
        this.loading = true;
        this.fileErrorMessage = '';
        const mediaType = getMediaType(file.type);
        this.fileData = {
          icon: getMediaIcon(mediaType),
          name: file.name,
        };

        const formData = new FormData();
        formData.append('file', file.file);

        this.uploadTempFile({
          message_id: this.message.id,
          data: formData,
        });
      }
    },
    setMessageType(type) {
      this.message.type = type;
      if (type === 'text') {
        this.$refs.messageArea.clear();
      }
    },
    changeRequiresReply(state) {
      this.message.requires_reply = state;
    },
    saveMessage() {
      this.saving = true;
      if (this.message.type === 'text') {
        this.message.text = this.$refs.messageArea.getText();
      }

      this.$validator.validate().then((valid) => {
        if (valid) {
          this.$emit('messageSaved', this.message);
          this.rollbackMessage = false;
          this.hide();
        } else {
          this.saving = false;
        }
      });
    },
  },
};
</script>
